export default {
    change_script_title: "Change Device Script",
    change_script_label: "Script",
    change_script_input: "IMEI or Serial",
    change_script_imei: "IMEI",
    change_script_serial: "Serial",
    change_script_model: "Model",
    change_script_change: "Change",
    change_script_no_devices_added: "No devices added",
    change_script_device_is_already_added: "The device is already added",
    change_script_device_has_not_been_found: "The device has not been found",
    change_script_this_feature_is_not_available: "This feature is not available",
    change_script_single_success_message: "The Script of the device has been changed",
    change_script_multiple_success_message: "The Script of the devices has been updated",
    change_script_error_message: "Unable to change Script due to an error",
    change_script_pre_loaded_script: "Pre-Loaded Script",
    change_script_assigned_script: "Assigned Script",
    change_script_script: "Script",
    change_script_assign: "Assign",
    change_script_no_script_devices: "There are devices without script configured",
    change_script_transaction_request_message:"The change script request has been received. Click here to see the change status.",
    change_script_warning_message_calamp_api:"The selected devices must be of the same calamp api",
    change_script_calamp_api:"Calamp Api",
    change_script_no_devices_selected: "No devices selected",
    change_script_no_scripts_selected: "No scripts selected",
}


